<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
               <el-form-item label="运维公司" >
					<el-select v-model="filters.operationcompanyId"  filterable  placeholder="请选择运维公司">
						<el-option
							v-for="item in operationcompanyList" :label="item.name" :value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item  label="型号规格">
					<el-input v-model="filters.modelname" placeholder="请输入型号规格"></el-input>
				</el-form-item>
                <el-form-item  label="制造厂商">
					<el-input v-model="filters.manufacturer" placeholder="请输入制造厂商"></el-input>
				</el-form-item>
                <el-form-item  label="准确度等级">
					<el-input v-model="filters.accuracylevel" placeholder="请输入准确度等级"></el-input>
				</el-form-item>
                <el-form-item  label="校准日期">
					<el-date-picker v-model="filters.calibrationdate" align="right" type="date" 
					format="yyyy-MM-dd"	value-format="yyyy-MM-dd" > </el-date-picker>
				</el-form-item>
				<el-form-item>
					<my-button  @select-type="clickBtn" QueryButtonShow AddButtonShow ResetButtonShow></my-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="DeviceCailss" highlight-current-row v-loading="listLoading"  style="width: 100%;" border :height="formHeight" size="mini">
			<el-table-column type="index" label="序号">
			</el-table-column>
            <el-table-column prop="operationcompanyName" label="所属公司">
			</el-table-column>
            <el-table-column prop="meteringutensil" label="计量器具名称">
			</el-table-column>
            <el-table-column prop="manufacturer" label="制造厂商">
			</el-table-column>
			<el-table-column prop="calibrationdate" label="校准日期">
			</el-table-column>
            <el-table-column prop="validuntil" label="有效期至">
			</el-table-column>
            <el-table-column  label="校准证书">
               <template slot-scope="scope">
                    <el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="scope.row.calibrationSrcList">  </el-image>
                </template>
			</el-table-column>
            <el-table-column  label="合格证书">
               <template slot-scope="scope">
                    <el-image   style="width: 30px; height: 16px;"  src="/static/query.png"   :preview-src-list="scope.row.certificateSrcList">  </el-image>
                </template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="scope">
					<table-update-button  @select-type="handleEdit(scope.$index, scope.row)" ></table-update-button>
					<table-delete-button  @select-type="handleDel(scope.$index, scope.row)"   v-if="usertype==0"></table-delete-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-pagination layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :total="total" style="float:right;" :page-sizes="[10, 20, 30,40,50]"   @size-change="handleSizeChange" :current-page.sync="page">
			</el-pagination>
		</el-col>

		<!--Form界面 角色修改、添加-->
		<el-dialog :title="type" :visible.sync="formVisible" :close-on-click-modal="false"  top="5vh">
			<el-form :model="formDeviceCails" label-width="120px" :rules="formRules" ref="formDeviceCails"  :inline="true" id="formDeviceCails"  size="mini">
            	<el-form-item label="所属公司" prop="operationcompanyId">
					<el-select v-model="formDeviceCails.operationcompanyId"  filterable  placeholder="请选择所属公司">
						<el-option
							v-for="item in operationcompanyList" :label="item.name" :value="item.id" :key="item.id">
						</el-option>
					</el-select>
				</el-form-item>
                <el-form-item label="证书号" prop="certificateno">
					<el-input v-model="formDeviceCails.certificateno" ></el-input>
				</el-form-item>
                  <el-form-item label="计量器具名称" prop="meteringutensil">
					<el-input v-model="formDeviceCails.meteringutensil" ></el-input>
				</el-form-item>
                  <el-form-item label="型号规格" prop="modelname">
					<el-input v-model="formDeviceCails.modelname" ></el-input>
				</el-form-item>
                <el-form-item label="制造厂商" prop="manufacturer">
					<el-input v-model="formDeviceCails.manufacturer" ></el-input>
				</el-form-item>
				<el-form-item label="生产编号" prop="factorynumber">
					<el-input v-model="formDeviceCails.factorynumber" ></el-input>
				</el-form-item>
                	<el-form-item label="准确度等级" prop="accuracylevel">
					<el-input v-model="formDeviceCails.accuracylevel" ></el-input>
				</el-form-item>
                	<el-form-item label="检验员" prop="inspector">
					<el-input v-model="formDeviceCails.inspector" ></el-input>
				</el-form-item>
                <el-form-item label="出厂日期" prop="exfactory">
					<el-date-picker v-model="formDeviceCails.exfactory" align="right" type="date" format="yyyy-MM-dd" 	value-format="yyyy-MM-dd"  > </el-date-picker>
				</el-form-item>
                	<el-form-item label="主管" prop="director">
					<el-input v-model="formDeviceCails.director" ></el-input>
				</el-form-item>
                <el-form-item label="校验" prop="checks">
					<el-input v-model="formDeviceCails.checks" ></el-input>
				</el-form-item>
                 <el-form-item label="校准" prop="calibration">
					<el-input v-model="formDeviceCails.calibration" ></el-input>
				</el-form-item>
				<el-form-item label="校准日期" prop="calibrationdate">
					<el-date-picker v-model="formDeviceCails.calibrationdate" align="right"  type="date" format="yyyy-MM-dd" 	value-format="yyyy-MM-dd" > </el-date-picker>
				</el-form-item>
                <el-form-item label="有效期至" prop="validuntil">
					<el-date-picker v-model="formDeviceCails.validuntil" align="right"  type="date" format="yyyy-MM-dd" 	value-format="yyyy-MM-dd" > </el-date-picker>
				</el-form-item>
                <el-form-item label="公司地址" prop="companyaddress">
					<el-input v-model="formDeviceCails.companyaddress" ></el-input>
				</el-form-item>
                <el-form-item label="邮编" prop="postalcode">
					<el-input v-model="formDeviceCails.postalcode" ></el-input>
				</el-form-item>
                <el-form-item label="电话" prop="telephone">
					<el-input v-model="formDeviceCails.telephone" ></el-input>
				</el-form-item>
                <el-form-item label="传真" prop="fax">
					<el-input v-model="formDeviceCails.fax" ></el-input>
				</el-form-item>
                <el-form-item label="网址" prop="website">
					<el-input v-model="formDeviceCails.website" ></el-input>
				</el-form-item>

                <el-form-item label="校准证书图片" prop="calibrationimage" style="width:100%" class="calibrationimage" id="calibrationimage">
					<el-upload class="upload-demo" action="#" :http-request="httpRequest" ref="upload" name="file" :on-change="changeCalibration" :on-remove="removeCalibration"
					 accept="image/*"  :file-list="fileListShowCalibration"  list-type="picture" multiple :auto-upload="false">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传图片文件，且最好不超过500kb</div>
					</el-upload>
				</el-form-item>

                <el-form-item label="合格证书图片" prop="certificateimage" style="width:100%" class="calibrationimage" id="certificateimage">
					<el-upload class="upload-demo" action="#" :http-request="httpRequest" ref="upload" name="file" :on-change="changeCertificate" :on-remove="removeCertificate"
					 accept="image/*"  :file-list="fileListShowCertificate"  list-type="picture" multiple :auto-upload="false">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传图片文件，且最好不超过500kb</div>
					</el-upload>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="cancleSubmit">取消</el-button>
				<el-button type="primary" @click.native="submitData" :loading="loading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	import { getDeviceCailsList,deleteDeviceCails,updateDeviceCails,addDeviceCails,getOperationCompanyList } from '../../api/api';
	import {formatDate} from '../../../static/fun.js';

	import myButton from '../../components/myButton/index.vue'
	import TableDeleteButton from '../../components/myButton/TableDeleteButton.vue'
	import TableUpdateButton from '../../components/myButton/TableUpdateButton.vue'

	export default {
	components: { myButton,TableUpdateButton,TableDeleteButton },
		data() {
			return {
				filters: {
					modelname: '',
                    manufacturer:'',
                    operationcompanyId:'',
                    accuracylevel:'',
                    calibrationdate:''
				},
				DeviceCailss: [ ],
				total: 0,
				page:1,
				pageSize:10,
				listLoading: false,
				type:'新增',

				formVisible: false,//修改界面是否显示
				loading: false,
				formRules: {
					certificateno: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
					meteringutensil: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
					modelname: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    manufacturer: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    factorynumber: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    accuracylevel: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    inspector: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    exfactory: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    director: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    checks: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    calibration: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    calibrationdate: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    validuntil: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    companyaddress: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    postalcode: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    telephone: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    fax: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    website: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
					operationcompanyId: [
						{ required: true, message: '必选', trigger: 'change' }
					],
					calibrationimage: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
                    certificateimage: [
						{ required: true, message: '必填', trigger: 'blur' }
					],
				},
				//修改界面数据
				formDeviceCails: {},
				formHeight:0,
                operationcompanyList:[ ],
				fileListCalibration: [],
				fileListShowCalibration:[],
				removeFileIdCalibration:[],
				lengthCalibration:0,
				calibrationNameList:[],

                fileListCertificate: [],
				fileListShowCertificate:[],
				removeFileIdCertificate:[],
				lengthCertificate:0,
				certificateNameList:[],
				usertype:sessionStorage.getItem("type"),
			}
		},
		methods: {
			clickBtn(type){
				if(type=="query"){
					this.getDeviceCailss();
				}else if(type=="add"){
					this.handleAdd();
				}else if(type=="reset"){
					this.reset();
				}
			},
			handleCurrentChange(val) {
				this.page=val;
				this.getDeviceCailss();
			},
			handleSizeChange(val){
				this.pageSize=val;
				this.getDeviceCailss();
			},
            reset(){
                this.filters={
                    modelname: '',
                    manufacturer:'',
                    operationcompanyId:'',
                    accuracylevel:'',
                    calibrationdate:''
                };
            },
            getOperationCompanyList(){
                if(this.operationcompanyList.length>0){
                    return;
                }
				getOperationCompanyList({}).then((res) => {
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					this.operationcompanyList = res.data.data;
				});
            },
			//获取用户列表
			getDeviceCailss() {
                let para = Object.assign({}, this.filters);
				if(para.calibrationdate==null){
					para.calibrationdate="";
				}
                para.page= this.page;
                para.pageSize=this.pageSize;

				this.listLoading = true;
				getDeviceCailsList(para).then((res) => {
					this.listLoading = false;
					if(res.data.result=="false"){
						this.$message({
							message: "数据查询失败，请重试",
							type: 'error'
						})
						return;
					}
					 this.total = res.data.total;
					 this.DeviceCailss = res.data.data;
                     this.DeviceCailss.forEach(element => {
                        var arr=[];
                        var imgarr=element.calibrationimage.split(';');
                        for(var j=0;j<imgarr.length;j++){
                            if(imgarr[j]==""){
                                continue;
                            }
                            var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
                            arr.push(url);
                        }
                        element.calibrationSrcList=arr;

                        arr=[];
                        imgarr=element.certificateimage.split(';');
                        for(var j=0;j<imgarr.length;j++){
                            if(imgarr[j]==""){
                                continue;
                            }
                            var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
                            arr.push(url);
                        }
                        element.certificateSrcList=arr;
					});
				});
			},
			httpRequest(){},
			removeCalibration:function(file, fileList){
				if(file.name==undefined){
					var i=0;
					this.fileListCalibration.forEach(element => {
						if(element.uid==file.uid){
							this.fileListCalibration.splice(i, 1);
							return;
						}
						i++;
					});
				}else{
					this.removeFileIdCalibration.push(file.name);
				}
			},
			changeCalibration:function(file, fileList){
				//判断上传文件数量
				this.lengthCalibration=document.getElementById("calibrationimage").querySelector("input[type=file]").files.length;
				if(this.lengthCalibration>0){
					Array.from(document.getElementById("calibrationimage").querySelector("input[type=file]").files).forEach(file=>{
						if(this.fileListCalibration.indexOf(file) == -1){
							this.fileListCalibration.push(file);
						}
					})
				}
				return false;
			},
            removeCertificate:function(file, fileList){
				if(file.name==undefined){
					var i=0;
					this.fileListCertificate.forEach(element => {
						if(element.uid==file.uid){
							this.fileListCertificate.splice(i, 1);
							return;
						}
						i++;
					});
				}else{
					this.removeFileIdCertificate.push(file.name);
				}
			},
			changeCertificate:function(file, fileList){
				//判断上传文件数量
				this.lengthCertificate=document.getElementById("certificateimage").querySelector("input[type=file]").files.length;
				if(this.lengthCertificate>0){
					Array.from(document.getElementById("certificateimage").querySelector("input[type=file]").files).forEach(file=>{
						if(this.fileListCertificate.indexOf(file) == -1){
							this.fileListCertificate.push(file);
						}
					})
				}
				return false;
			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该条记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.loading = true;
					let param = new URLSearchParams()
					param.append('id', row.id)
					deleteDeviceCails(param).then((res) => {
						this.loading = false;
                        if(res.data.result=="false"){
                            this.$message({
                                message: "操作失败，请重试",
                                type: 'error'
                            })
                        }else{
                            this.$message({ 
								message: '操作成功',
								type: 'success'
							});
                        }
						this.getDeviceCailss();
					});
				}).catch(() => {

				});
			},
			//显示修改界面
			handleEdit: function (index, row) {
				this.removeFileIdCalibration=[];
                this.removeFileIdCertificate=[];
				this.fileListCertificate=[];
				this.fileListCalibration=[];

				this.calibrationNameList=[];
				this.certificateNameList=[];

				this.formVisible = true;
				if( this.$refs.formDeviceCails!=undefined){
               		this.$refs.formDeviceCails.resetFields();
				}
				this.type='修改';

				this.fileListShowCalibration=[];
				var imgarr=row.calibrationimage.split(';');
				for(var j=0;j<imgarr.length;j++){
					if(imgarr[j]==""){
						continue;
					}
					var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
					var obj={
						url:url,
						name:imgarr[j]
					}
					this.fileListShowCalibration.push(obj);
				}
                this.fileListShowCertificate=[];
				var imgarr=row.certificateimage.split(';');
				for(var j=0;j<imgarr.length;j++){
					if(imgarr[j]==""){
						continue;
					}
					var url=window.configuration.resourceUrlJava+"photo/"+imgarr[j];
					var obj={
						url:url,
						name:imgarr[j]
					}
					this.fileListShowCertificate.push(obj);
				}
				this.formDeviceCails = Object.assign({}, row);
			},
			//显示新增界面
			handleAdd: function () {
				this.fileListShowCalibration=[];
                this.fileListShowCertificate=[];
				this.fileListCertificate=[];
                this.removeFileIdCalibration=[];
                this.removeFileIdCertificate=[];
				this.fileListCalibration=[];

				this.calibrationNameList=[];
				this.certificateNameList=[];

				this.formVisible = true;
				if( this.$refs.formDeviceCails!=undefined){
               		this.$refs.formDeviceCails.resetFields();
				}
				this.type='新增';
				
				this.formDeviceCails = {
					calibrationimage: '11',
                    certificateimage: '11',
				}
			},
			//Form表单提交
            submitData:function(){
                if(this.type=='修改'){
                   this.editSubmit();
                }else{
                     this.addSubmit();
                }
            },
			//修改
			editSubmit: function () {
				this.$refs.formDeviceCails.validate((valid) => {
					if (valid) {
						if(this.fileListCertificate.length+this.formDeviceCails.certificateSrcList.length<=this.removeFileIdCertificate.length){
							this.$message({
								message: "请上传合格证书图片再提交",
								type: 'error'
							})
							return;
						}
                        if(this.fileListCalibration.length+this.formDeviceCails.calibrationSrcList.length<=this.removeFileIdCalibration.length){
							this.$message({
								message: "请上传校准证书图片再提交",
								type: 'error'
							})
							return;
						}
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.loading = true;
							let formData = new FormData();
							var i=0;
							this.fileListCertificate.forEach(file=> {
								formData.append("fileListCertificate"+i, file);
								this.certificateNameList.push(file.name);
								i++;
							});

                            var j=0;
							this.fileListCalibration.forEach(file=> {
								formData.append("fileListCalibration"+j, file);
								this.calibrationNameList.push(file.name);
								j++;
							});

							formData.append("removeFileIdCertificate",this.removeFileIdCertificate.toString());
                            formData.append("removeFileIdCalibration",this.removeFileIdCalibration.toString());

							formData.append("id",this.formDeviceCails.id);
                            formData.append("certificateno",this.formDeviceCails.certificateno);
                            formData.append("meteringutensil",this.formDeviceCails.meteringutensil);
                            formData.append("modelname",this.formDeviceCails.modelname);
                            formData.append("manufacturer",this.formDeviceCails.manufacturer);
                            formData.append("factorynumber",this.formDeviceCails.factorynumber);
                            formData.append("accuracylevel",this.formDeviceCails.accuracylevel);
                            formData.append("inspector",this.formDeviceCails.inspector);
                            formData.append("exfactory",this.formDeviceCails.exfactory);
                            formData.append("director",this.formDeviceCails.director);
                            formData.append("checks",this.formDeviceCails.checks);
                            formData.append("calibration",this.formDeviceCails.calibration);
                            formData.append("calibrationdate",this.formDeviceCails.calibrationdate);
                            formData.append("validuntil",this.formDeviceCails.validuntil);
                            formData.append("companyaddress",this.formDeviceCails.companyaddress);
                            formData.append("postalcode",this.formDeviceCails.postalcode);
							formData.append("telephone",this.formDeviceCails.telephone);
							formData.append("fax",this.formDeviceCails.fax);
							formData.append("website",this.formDeviceCails.website);
							formData.append("operationcompanyId",this.formDeviceCails.operationcompanyId);
							formData.append("calibrationimage",this.formDeviceCails.calibrationimage);
							formData.append("certificateimage",this.formDeviceCails.certificateimage);

							formData.append("calibrationNameList",this.calibrationNameList.toString());
							formData.append("certificateNameList",this.certificateNameList.toString());

							updateDeviceCails(formData).then((res) => {
								this.loading = false;
								if(res.data.result=="false"){
									this.$message({
										message: "数据操作失败，请重试",
										type: 'error'
									})
									return;
								}
								this.$message({
									message: '操作成功',
									type: 'success'
								});
                                this.fileListShowCalibration=[];
                                this.fileListShowCertificate=[];
                                this.removeFileIdCalibration=[];
                                this.removeFileIdCertificate=[];
								this.formVisible = false;
								this.getDeviceCailss();
							}).catch(error => {
								this.loading = false;
								this.$message({
									message: "数据操作失败，可能是文件过大",
									type: 'error'
								})
								return;
							});
						});
					}
				});
			},
			//新增
			addSubmit: function () {
				this.$refs.formDeviceCails.validate((valid) => {
					if (valid) {
						if(this.fileListCertificate.length==0){
							this.$message({
								message: "请上传合格证书图片再提交",
								type: 'error'
							})
							return;
						}
                        if(this.fileListCalibration.length==0){
							this.$message({
								message: "请上传校准证书图片再提交",
								type: 'error'
							})
							return;
						}
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							let formData = new FormData();
							var i=0;
							this.fileListCertificate.forEach(file=> {
								formData.append("fileListCertificate"+i, file);
								this.certificateNameList.push(file.name);
								i++;
							});

                            var j=0;
							this.fileListCalibration.forEach(file=> {
								formData.append("fileListCalibration"+j, file);
								this.calibrationNameList.push(file.name);
								j++;
							});

                            formData.append("certificateno",this.formDeviceCails.certificateno);
                            formData.append("meteringutensil",this.formDeviceCails.meteringutensil);
                            formData.append("modelname",this.formDeviceCails.modelname);
                            formData.append("manufacturer",this.formDeviceCails.manufacturer);
                            formData.append("factorynumber",this.formDeviceCails.factorynumber);
                            formData.append("accuracylevel",this.formDeviceCails.accuracylevel);
                            formData.append("inspector",this.formDeviceCails.inspector);
                            formData.append("exfactory",this.formDeviceCails.exfactory);
                            formData.append("director",this.formDeviceCails.director);
                            formData.append("checks",this.formDeviceCails.checks);
                            formData.append("calibration",this.formDeviceCails.calibration);
                            formData.append("calibrationdate",this.formDeviceCails.calibrationdate);
                            formData.append("validuntil",this.formDeviceCails.validuntil);
                            formData.append("companyaddress",this.formDeviceCails.companyaddress);
                            formData.append("postalcode",this.formDeviceCails.postalcode);
							formData.append("telephone",this.formDeviceCails.telephone);
							formData.append("fax",this.formDeviceCails.fax);
							formData.append("website",this.formDeviceCails.website);
							formData.append("operationcompanyId",this.formDeviceCails.operationcompanyId);
							formData.append("calibrationimage","");
							formData.append("certificateimage","");

							formData.append("calibrationNameList",this.calibrationNameList.toString());
							formData.append("certificateNameList",this.certificateNameList.toString());

							this.loading = true;
							addDeviceCails(formData).then((res) => {
								this.loading = false;
								if(res.data.result=="false"){
									this.$message({
										message: "数据操作失败，请重试",
										type: 'error'
									})
									return;
								}
								this.$message({
									message: '操作成功',
									type: 'success'
								});
                                this.fileListShowCalibration=[];
                                this.fileListShowCertificate=[];
                                this.removeFileIdCalibration=[];
                                this.removeFileIdCertificate=[];
								this.formVisible = false;
								this.getDeviceCailss();
							}).catch(error => {
								this.loading = false;
								this.$message({
									message: "数据操作失败，可能是文件过大",
									type: 'error'
								})
								return;
							});
						});
					}
				});
			},
			//取消按钮
            cancleSubmit:function(){
				this.formVisible=false;
			},
			SetHeight:function(){
				var hgt=document.getElementsByClassName('content-container')[0].clientHeight;
				var titleHgt=document.getElementsByClassName('tags-view-wrapper')[0].clientHeight;
				var toolbarHgt=document.getElementsByClassName('toolbar')[0].clientHeight+document.getElementsByClassName('toolbar')[1].clientHeight;
				this.formHeight=hgt-titleHgt-toolbarHgt-100;
			}
		},
		mounted() {
			var _this=this;
			var timer=null;
			clearInterval(timer);
			timer =setInterval(function(){
				if(_this.formHeight ==0){
					_this.SetHeight();
				}else{
					clearInterval(timer);
				}
			},10)
			this.getDeviceCailss();
            this.getOperationCompanyList();
		}
	}

</script>

<style scoped>
	.containerDeviceCails{
		display: flex;
	}
	.containerDeviceCails .block {
		-ms-flex: 1;
		flex: 1;
		padding: 0 24px;
	}
	.containerDeviceCails .title{
		font-weight: bold;
		margin-bottom: 10px;
	}
    #formDeviceCails .el-form-item{
        width: 45%;
    }

</style>
	
<style>
	#formDeviceCails .calibrationimage{
		width: 100%!important;
	}
	#formDeviceCails .calibrationimage .el-form-item__content{
		width:80%;
	}
	#formDeviceCails .el-form-item__content{
		width: calc(100% - 150px) ;
	}
</style>


// WEBPACK FOOTER //
// DeviceCalibration.vue?3c09bc12